var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "briefShopInfoMain" }, [
    _c("div", { staticStyle: { height: "10px" } }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contentWrapper" },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              width: "100%"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "flex-grow": "1", "overflow-x": "hidden" } },
              [
                _c(
                  "span",
                  {
                    staticClass: "shopNickname",
                    on: { click: _vm.goAuthTest }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.shopInfo ? _vm.shopInfo.shopNickname : "")
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "anouncement" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: { "flex-shrink": "0" }
                      },
                      [_vm._v("公告: ")]
                    ),
                    _vm._v(" "),
                    _c("BaseAutoHorizonScroll", {
                      staticClass: "content",
                      staticStyle: {
                        "flex-grow": "1",
                        "white-space": "nowrap",
                        "overflow-y": "auto"
                      },
                      attrs: {
                        text: _vm.shopInfo ? _vm.shopInfo.shopAnnouncement : ""
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "shopImg",
              attrs: {
                loading: "lazy",
                src: _vm.getImgUrl(_vm.shopInfo ? _vm.shopInfo.shopLogo : "")
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.description.discountInfoList != null &&
        _vm.description.discountInfoList.length > 0
          ? [
              _c("div", { staticClass: "horizonGully" }),
              _vm._v(" "),
              _vm.ifShowCoupon
                ? _c(
                    "div",
                    {
                      staticClass: "couponWrapper",
                      on: {
                        click: function($event) {
                          _vm.ifShowCoupon = false
                        }
                      }
                    },
                    [
                      _c("div", [_vm._v("点击隐藏")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(
                          _vm.description.discountInfoList
                            ? _vm.description.discountInfoList
                            : [],
                          function(ref, index) {
                            var img = ref.img
                            var icon = ref.icon
                            var content = ref.content
                            return _c(
                              "div",
                              { key: "discountInfoList" + index },
                              [
                                img
                                  ? _c("img", {
                                      staticClass: "couponImg",
                                      attrs: {
                                        src:
                                          "" +
                                          _vm.getShopStaticResouceUrl() +
                                          img
                                      }
                                    })
                                  : icon
                                  ? _c("i", {
                                      class: ["iconfont", icon],
                                      staticStyle: {
                                        "vertical-align": "middle"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "vertical-align": "middle" }
                                  },
                                  [_vm._v(_vm._s(content))]
                                )
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { on: { click: _vm.goToMyCoupons } }, [
                        _c(
                          "div",
                          { staticStyle: { display: "inline-block" } },
                          [
                            _c("img", {
                              staticClass: "couponRedEnvelopImg",
                              attrs: {
                                src: _vm.getImgUrl("/images/red-packet.gif")
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "vertical-align": "middle" } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.description.coupons
                                        ? _vm.description.coupons.content
                                        : ""
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "couponWrapper",
                      on: {
                        click: function($event) {
                          _vm.ifShowCoupon = true
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("点击显示更多优惠")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "flex-grow": "1",
                            "white-space": "nowrap",
                            overflow: "hidden"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.description.discountInfoList[0].content)
                          )
                        ]
                      )
                    ]
                  )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }